<template>
  <header v-if="!(activeStep === 2)">
    <nav>
      <router-link :to="{ name: 'Home' }" class="logo">DOLAS</router-link>
      <div class="checkout-stepper">
        <el-steps :active="activeStep" align-center>
          <el-step title="Shipping" />
          <el-step title="Payment" />
          <el-step title="Review" />
        </el-steps>
      </div>
    </nav>
  </header>

  <the-navigation class="nav" v-if="activeStep === 2"></the-navigation>

  <loading-page v-if="isLoading"></loading-page>

  <div class="container">
    <div v-if="activeStep === 0 && !isLoading" class="step-container">
      <div class="step">
        <div class="step-number"><span>1</span></div>
        <p class="step-name">Shipping</p>
      </div>
      <input
        class="base-input"
        v-model="localAddressData.firstName"
        type="text"
        placeholder="Name"
      />
      <input
        class="base-input"
        v-model="localAddressData.lastName"
        type="text"
        placeholder="Surname"
      />
      <input
        class="base-input"
        v-model="localAddressData.email"
        type="text"
        placeholder="Email Address"
      />
      <p class="order-info-text">
        Required for order confirmation and item tracking.
      </p>
      <div class="delivery-container">
        <img src="/images/courier.svg" alt="" />
        <div class="delivery-info">
          <p class="delivery-heading">Courier delivery</p>
          <p class="delivery-time">Delivery within 3-10 days.</p>
          <p class="delivery-cost">from 40$</p>
        </div>
        <input
          type="radio"
          value="courier"
          name="delivery"
          class="delivery-type"
          v-model="selected"
        />
      </div>
      <div class="delivery-container">
        <img src="/images/point.svg" alt="" />
        <div class="delivery-info">
          <p class="delivery-heading">Delivery to point of issue</p>
          <p class="delivery-time">Delivery within 4-10 days.</p>
          <p class="delivery-cost">from 20$</p>
        </div>
        <input
          type="radio"
          name="delivery"
          value="point"
          class="delivery-type"
          v-model="selected"
        />
      </div>
      <button
        @click="openPopup"
        v-if="selected === 'point'"
        class="pop-up-activator"
      >
        Choose your city and point of issue
      </button>
      <p class="info">Information</p>
      <p v-if="addressError" class="error">{{ addressError }}</p>
      <input
        class="base-input"
        :value="localAddressData.street"
        type="text"
        placeholder="Street Address"
      />
      <input
        class="base-input"
        :value="localAddressData.house"
        type="text"
        placeholder="House Number"
      />
      <div class="input-container">
        <input
          class="base-input"
          :value="localAddressData.zip"
          type="text"
          placeholder="Zip Code"
        />
        <input
          class="base-input"
          :value="localAddressData.city"
          type="text"
          placeholder="City"
        />
      </div>
      <input
        class="base-input"
        v-model="localAddressData.phone"
        type="text"
        placeholder="Phone Number"
      />
      <div v-if="activeStep === 0" class="step-controls">
        <button @click="nextStep">Next Step</button>
      </div>
    </div>

    <div v-if="activeStep === 1 && !isLoading" class="step-container">
      <div class="step">
        <div class="step-number"><span>2</span></div>
        <p class="step-name">Payment</p>
      </div>
      <div class="payment-methods">
        <img src="/images/cash.svg" alt="" />
        <p>Cash on delivery</p>
        <input
          type="radio"
          value="cash"
          name="paymentMethod"
          class="delivery-type payment"
          v-model="paymentMethod"
        />
      </div>
      <div class="payment-methods">
        <img src="/images/mastercard.svg" alt="" />
        <p>Payment by card</p>
        <input
          type="radio"
          value="master-card"
          name="paymentMethod"
          class="delivery-type payment"
          v-model="paymentMethod"
        />
      </div>
      <div class="payment-methods">
        <img src="/images/applePay.svg" alt="" />
        <p>Payment by ApplePay</p>
        <input
          type="radio"
          value="ApplePay"
          name="paymentMethod"
          class="delivery-type payment"
          v-model="paymentMethod"
        />
      </div>
      <div class="payment-methods">
        <img src="/images/googlePay.svg" alt="" />
        <p>Payment by GooglePay</p>
        <input
          type="radio"
          value="GooglePay"
          name="paymentMethod"
          class="delivery-type payment"
          v-model="paymentMethod"
        />
      </div>
      <button @click="nextStep" class="checkout">Checkout</button>
    </div>

    <div class="cart" v-if="!(activeStep === 2)">
      <ul>
        <div v-if="activeStep === 0 && !isLoading" class="top-info">
          <p class="your-items">Your items:</p>
          <router-link :to="cartRoute" class="edit">Edit Bag</router-link>
        </div>
        <li
          v-for="product in formattedCart"
          :key="product._id + product.size"
          class="product-info"
        >
          <div class="info-pop-up">
            <div class="image-container">
              <img
                v-if="product.productId && product.productId.image"
                :src="product.productId.image"
                :alt="product.productId.name"
                class="product-image"
              />
            </div>
            <div class="text-info">
              <p v-if="product.productId" class="heading-pop-up">
                {{ product.productId.name }}
              </p>
              <p v-if="product.productId" class="product-price">
                Price: {{ product.totalPrice }}$
              </p>
              <p v-if="product.productId" class="product-color">
                Color: {{ getColorName(product.productId.color) }}
              </p>
              <p v-if="product.productId" class="product-size">
                Size: {{ product.size }}
              </p>
              <p v-if="product.productId" class="product-quantity">
                Quantity: {{ product.quantity }}
              </p>
            </div>
          </div>
        </li>
        <div v-if="!isLoading" class="price-info-pop-up">
          <hr />
          <div class="promocode">
            <p class="promocode-text">Promocode</p>
            <p class="promocode-text-value">-</p>
          </div>
          <div class="delivery">
            <p class="delivery-text">Delivery</p>
            <p class="delivery-text-value">20.00$</p>
          </div>
        </div>
        <hr />
        <div v-if="!isLoading" class="total-price">
          <p class="total-text">Total:</p>
          <p class="total-text-value">{{ totalPrice }}$</p>
        </div>
      </ul>
    </div>
  </div>

  <div v-if="activeStep === 2" class="final-step-container">
    <h1 class="final-step-heading">Thank you for order</h1>
    <p class="final-step-paragraph">
      Thanks for order! You can track your package in your profile or wait for
      new messages on your e-mail.
    </p>
    <div class="final-step-button-container">
      <button></button>
      <button></button>
    </div>
  </div>

  <div v-if="isPopupOpen" class="popup-overlay">
    <div class="popup-content">
      <div class="btn-container">
        <button class="close" @click="closePopup">
          <img src="/images/cross.svg" alt="" />
        </button>
      </div>
      <MapPicker @location-selected="onLocationSelected"></MapPicker>
    </div>
  </div>
  <the-footer v-if="activeStep === 2"></the-footer>
</template>
  
<script>
import namer from "color-namer";
import { mapGetters } from "vuex";
import MapPicker from "./MapPicker.vue";
import TheNavigation from "./TheNavigation.vue";
import TheFooter from "./TheFooter.vue";
export default {
  components: { MapPicker, TheNavigation, TheFooter },

  props: {
    addressData: {
      type: Object,
      default() {
        return {
          street: "",
          house: "",
          zip: "",
          city: "",
        };
      },
    },
  },

  data() {
    return {
      activeStep: 0,
      isLoading: true,
      selected: null,
      paymentMethod: null,
      isPopupOpen: false,
      addressError: "",

      localAddressData: {
        street: "",
        house: "",
        zip: "",
        city: "",
        firstName: "",
        lastName: "",
        email: "",
        phone: "",
      },
    };
  },

  computed: {
    ...mapGetters("cart", ["getCart"]),

    userId() {
      const userData = this.$store.getters.userData;
      return userData && userData.id ? userData.id : "guest";
    },

    cartRoute() {
      return `/Cart/${this.userId}`;
    },

    totalPrice() {
      return this.formattedCart.reduce(
        (sum, product) => sum + product.totalPrice,
        20
      );
    },

    formattedCart() {
      if (this.userId === "guest") {
        return this.getCart.map((product) => {
          const price = product.productId?.price || 0;
          const quantity = Number(product.quantity);
          return {
            _id: product._id,
            productId: product.productId,
            size: product.size,
            quantity,
            totalPrice: price * quantity,
          };
        });
      } else {
        return (this.getCart.products || []).map((product) => {
          const price = product.productId?.price || 0;
          const quantity = product.quantity || 1;
          return {
            ...product,
            totalPrice: price * quantity,
          };
        });
      }
    },
  },

  methods: {
    nextStep() {
      console.log("Next step clicked");
      if (this.activeStep === 0) {
        const isValid = this.validateAddressFields();
        if (isValid) {
          this.activeStep++;
        }
      }
      if (this.activeStep === 1 && this.paymentMethod) {
        this.activeStep++;

        const userInfo = JSON.parse(localStorage.getItem("userPaymentInfo"));

        const productIds = this.formattedCart.map((item) => {
          const id = item.productId?._id || item.productId;
          const size = item.size || "no-size";
          return `${id}_${size}`;
        });

        const quantities = this.formattedCart.map((item) => item.quantity);

        userInfo.paymentMethod = this.paymentMethod;
        userInfo.userId = this.userId;
        userInfo.productId = productIds;
        userInfo.quantities = quantities;

        localStorage.setItem("userPaymentInfo", JSON.stringify(userInfo));

        if (this.userId != "guest") {
          this.submitOrder();
          console.log("not guest");
        }
      }
    },

    async submitOrder() {
      try {
        const userInfo = JSON.parse(localStorage.getItem("userPaymentInfo"));
        console.log("Отправляем в заказ:", userInfo);
        const res = await fetch(`${process.env.VUE_APP_URL}/orders`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(userInfo),
        });

        if (!res.ok) {
          const err = await res.json();
          console.error(err);
          throw new Error();
        }

        const data = await res.json();
        console.log(data);
      } catch (error) {
        console.error(error);
      }
    },

    getColorName(hex) {
      if (!hex) return "unknown";
      return namer(hex).html[0].name;
    },

    openPopup() {
      this.isPopupOpen = true;
    },

    closePopup() {
      this.isPopupOpen = false;
    },

    validateAddressFields() {
      const { street, house, zip, city, firstName, lastName, email, phone } =
        this.localAddressData;

      if (
        !street ||
        !house ||
        !zip ||
        !city ||
        !firstName ||
        !lastName ||
        !email ||
        !phone
      ) {
        console.log(
          street,
          house,
          zip,
          city,
          firstName,
          lastName,
          email,
          phone
        );

        this.addressError = "Please fill in all required fields.";
        return false;
      }
      this.addressError = "";

      // Сохраняем всё в localStorage
      localStorage.setItem(
        "userPaymentInfo",
        JSON.stringify(this.localAddressData)
      );

      return true;
    },

    onLocationSelected(location) {
      this.localAddressData.street = location.street || "";
      this.localAddressData.house = location.house || "";
      this.localAddressData.zip = location.zip || "";
      this.localAddressData.city = location.city || "";
      this.closePopup();
    },
  },

  async mounted() {
    this.localAddressData = { ...this.addressData };

    this.$store.dispatch("checkLoggedIn");
    const userData = this.$store.getters.userData;
    const userId = userData && userData.id ? userData.id : "guest";
    const data = await this.$store
      .dispatch("cart/fetchCart", userId)
      .then(() => {
        this.isLoading = false;
      });
    console.log("ordering:", data);
  },
};
</script>
  
<style scoped>
nav {
  display: flex;
  align-items: center;
  background: none;
  padding: 0 40px;
  border-bottom: 1px solid #000;
  position: static;
  margin-bottom: 50px;
}

.logo {
  color: #000;
  font-family: "Glusp";
  font-size: 2.6rem;
}

.container {
  padding: 0 160px 40px 40px;
  display: flex;
  justify-content: space-between;
}

ul {
  list-style-type: none;
}

.checkout-stepper {
  min-width: 600px;
  max-width: 650px;
  margin: auto;
  padding: 24px 0;
  flex-shrink: 0;
}

.step-content {
  margin-top: 32px;
  min-height: 120px;
  background: #fafafa;
  padding: 16px;
  border-radius: 8px;
}

.step-controls {
  display: flex;
  justify-content: flex-start;
  gap: 30px;
  margin-top: 24px;
}

.step-controls button,
.checkout {
  color: #fff;
  font-family: "Mabry Pro";
  font-size: 2rem;
  font-weight: 500;
  border-radius: 4.073px;
  background: #000;
  padding: 8px 18px;
  text-align: center;
}

::v-deep(.el-step__icon) {
  background: #000;
  height: 30px;
  width: 30px;
}

::v-deep(.el-step__icon.is-text) {
  border: none;
}

::v-deep(.el-step__icon-inner) {
  color: #fff;
  font-family: "Mabry Pro";
  font-size: 1.6rem;
  font-weight: 300;
}

::v-deep(.el-step__title) {
  color: #000;
  font-family: "Mabry Pro";
  font-size: 1.6rem;
  font-weight: 500;
}

.page-content {
  padding: 0;
}

.cart {
  max-width: 50rem;
}

.top-info {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

.your-items {
  color: #000;
  font-family: "Mabry Pro";
  font-size: 1.8rem;
  font-weight: 300;
}

.edit {
  color: #0085ff;
  font-family: "Mabry Pro";
  font-size: 1.6rem;
  font-weight: 300;
  text-decoration-line: underline;
}

.info-pop-up {
  display: flex;
  gap: 20px;
  margin-bottom: 20px;
}

.product-image {
  height: 25rem;
}

.text-info {
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-bottom: 10px;
}

.heading-pop-up {
  color: #000;
  font-family: "Mabry Pro";
  font-size: 2.4rem;
  font-weight: 500;
}

.product-price,
.product-size,
.product-color,
.product-quantity,
.payment-methods p {
  color: #000;
  font-family: "Mabry Pro";
  font-size: 2rem;
  font-weight: 300;
}

.promocode,
.delivery {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;
}

.promocode {
  margin-top: 12px;
}

.promocode-text,
.delivery-text {
  color: #000;
  font-family: "Mabry Pro";
  font-size: 1.6rem;
  font-weight: 300;
}

.promocode-text-value {
  color: #000;
  font-family: "Mabry Pro";
  font-size: 1.6rem;
  font-weight: 300;
}

.delivery-text-value {
  color: #000;
  font-family: "Mabry Pro";
  font-size: 1.6rem;
  font-weight: 500;
}

.total-price {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.total-text {
  color: #000;
  font-family: "Mabry Pro";
  font-size: 2.4rem;
  font-weight: 300;
}

.total-text-value {
  color: #000;
  font-family: "Mabry Pro";
  font-size: 2.2rem;
  font-weight: 500;
}

.step-container {
  display: flex;
  flex-direction: column;
  gap: 40px;
}

.step {
  display: flex;
  align-items: center;
  gap: 30px;
  border-bottom: 1px solid #000;
  min-width: 45rem;
  padding-bottom: 10px;
}

.step-number {
  height: 50px;
  width: 50px;
  background: #000;
  border-radius: 50%;

  display: flex;
  justify-content: center;
  align-items: center;
}

.step-number span {
  color: #fff;
  font-family: "Mabry Pro";
  font-size: 3.4rem;
  font-weight: 300;
}

.step-name {
  color: #000;
  font-family: "Mabry Pro";
  font-size: 3rem;
  font-weight: 500;
  text-transform: uppercase;
}

input::placeholder {
  color: rgba(0, 0, 0, 0.6);
  font-family: "Mabry Pro";
  font-size: 2.2rem;
  font-weight: 300;
}

.base-input {
  background: none;
  outline: none;
  border: none;
  border-bottom: 1px solid #000;
  max-width: 28rem;
  height: 6rem;
  color: #000;
  font-family: "Mabry Pro";
  font-size: 2.2rem;
  font-weight: 300;
  padding-left: 15px;
}

.order-info-text {
  color: #000;
  font-family: "Mabry Pro";
  font-size: 1.8rem;
  font-weight: 300;
}

.delivery-container {
  display: flex;
  align-items: center;
  background: #fff;
  border-radius: 2px;
  border: 1px solid rgba(0, 0, 0, 0.5);
  padding: 15px 40px 15px 15px;
  gap: 20px;
}

.delivery-info {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.delivery-heading {
  color: #000;
  font-family: "Mabry Pro";
  font-size: 1.8rem;
  font-weight: 500;
}

.delivery-time {
  color: #000;
  font-family: "Mabry Pro";
  font-size: 1.6rem;
  font-weight: 300;
}

.delivery-cost {
  color: #038700;
  font-family: "Mabry Pro";
  font-size: 2rem;
  font-weight: 300;
}

.delivery-type {
  margin-left: auto;
  width: 40px;
  height: 40px;
  appearance: none;
  -webkit-appearance: none;
  background: #d9d9d9;
  border-radius: 50%;
  position: relative;
  cursor: pointer;
  transition: background 0.3s;
}

.delivery-type::after {
  content: "";
  position: absolute;
  top: 10px;
  left: 10px;
  width: 20px;
  height: 20px;
  background-color: #a7a7a7;
  border-radius: 50%;
  opacity: 0;
  transition: opacity 0.3s;
}

.delivery-type:checked::after {
  opacity: 1;
}

.info {
  color: #000;
  font-family: "Mabry Pro";
  font-size: 2.2rem;
  font-weight: 500;
}

.input-container {
  display: flex;
  gap: 40px;
}

.pop-up-activator {
  color: rgba(0, 0, 0, 0.6);
  font-family: "Mabry Pro";
  font-size: 2.2rem;
  font-weight: 300;

  border-radius: 2px;
  border: 1px solid rgba(0, 0, 0, 0.4);
  padding: 20px 10px;
  max-width: 40rem;
}

/* pop-up */
.popup-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5); /* Полупрозрачный фон */
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.popup-content {
  padding: 20px 0;
  border-radius: 5px;
  border: 1px solid rgba(0, 0, 0, 0.2);
  background: #fff;
  text-align: center;
  max-width: 100rem;
  width: 100%;
}

.btn-container {
  display: flex;
  justify-content: flex-end;
  padding-right: 20px;
}

.close {
  background: none;
  outline: none;
}

.close img {
  height: 32px;
  width: 32px;
  margin-left: auto;
}

.payment-methods {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.payment-methods img {
  height: 60px;
  width: 60px;
}

.payment {
  margin: 0;
}

.nav {
  height: 100px;
}

.final-step-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 50px;
  height: 500px;
}

.final-step-heading {
  color: #000;
  font-family: "Glusp";
  font-size: clamp(2.8rem, 5vw, 3.6rem);
  text-align: center;
  font-weight: 700;
}

.final-step-paragraph {
  color: #000;
  text-align: center;
  font-family: "Mabry Pro";
  font-size: clamp(2.2rem, 5vw, 2.8rem);
  font-weight: 300;
  max-width: 52rem;
}

@media screen and (min-width: 240px) and (max-width: 480px) {
  nav {
    padding: 30px;
    display: flex;
    justify-content: center;
  }

  .checkout-stepper {
    display: none;
  }
  .container {
    flex-direction: column;
    padding: 0 20px;
  }
  .step-container {
    width: 100%;
    margin-bottom: 50px;
  }
  .step {
    min-width: 32rem;
  }
  .input-container {
    flex-direction: column;
  }
  .delivery-container {
    flex-direction: column;
  }
  .delivery-type {
    margin-left: 0;
  }
  .info-pop-up {
    flex-direction: column;
  }
}

@media screen and (min-width: 481px) and (max-width: 768px) {
  nav {
    padding: 30px;
    display: flex;
    justify-content: center;
  }

  .checkout-stepper {
    display: none;
  }

  .container {
    flex-direction: column;
    padding: 0 20px;
  }

  .step-container {
    width: 100%;
    margin-bottom: 50px;
  }

  .step {
    min-width: 32rem;
  }

  .input-container {
    flex-direction: column;
  }
  /* .delivery-container {
    flex-direction: column;
  }
  .delivery-type {
    margin-left: 0;
  } */
  .info-pop-up {
    flex-direction: column;
  }
}

@media screen and (min-width: 769px) and (max-width: 1024px) {
  .container {
    flex-direction: column;
    padding: 0 20px;
  }
  .step-container {
    width: 100%;
    margin-bottom: 50px;
  }
}

@media screen and (min-width: 1025px) and (max-width: 1200px) {
  
}

@media screen and (min-width: 1200px) and (max-width: 1900px) {
}
</style>
